import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ViewChild, ElementRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';

import { languageSupport, languageService } from '@app/modules/common/language';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-modal-cashpay',
    templateUrl:'./ui-cash.html',
    styleUrls: [ 
        './ui-cash.scss'
    ]
})
export class UiCashPayModal extends languageSupport implements OnInit, OnDestroy {
    public _tickets: Array<Ticket> = [];

    get AmountToPay(){
        let _totalprice = 0;
        for(let _ticket of this._tickets){
            _totalprice += _ticket.price;
        }
        _totalprice = Math.round(_totalprice * 100) / 100;

        return _totalprice.toFixed(2);
    }

    get CanAccept(){
        return !this.AmountReturn || (this.AmountReturn >= 0);
    }

    private _amount = null;
    get AmountPaid(){
        return this._amount;
    }

    set AmountPaid(value: string){
        this._amount = (isNaN(parseFloat(value))) || (parseFloat(value) <= 0) ? null : value;
    }
    
    get AmountReturn(){
        if (this.AmountPaid){
            return Math.round((parseFloat(this.AmountPaid) - parseFloat(this.AmountToPay)) * 100)/100;
        }
        return null;
    }

    get AmountMissing(){
        if (this.AmountPaid){
            return Math.round((parseFloat(this.AmountToPay) - parseFloat(this.AmountPaid)) * 100)/100;
        }
        return null;
    }
    	
    /************************/
    /* STARTS HERE          */
    /************************/

    constructor(private lang: languageService, private modalCtrl: ModalController, private params: NavParams, public view: viewService) {
        super(lang, null);
    }

    ngOnInit() {
        this._tickets = this.params.get('tickets');
        let _amountpaid = 0;
        for(let _ticket of this._tickets){
            if ((_ticket.status == 'PP') && (_ticket.given)){
                _amountpaid += _ticket.given;
            }
        }

        _amountpaid = Math.round(_amountpaid * 100) / 100;
        if (_amountpaid > 0){
            this.AmountPaid = _amountpaid.toString();
        }
    }
    
    ngOnDestroy(){
        super.OnDestroy();
    }


    Price(price){
        let _parts = Math.abs(price).toString().split('.');

        let _int = _parts[0];
        let _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";

        return _int + ',' + _dec;
    }

    async AcceptModal() {
        await this.modalCtrl.dismiss({ amount: this.AmountPaid });
    }    

    async CloseModal() {
        await this.modalCtrl.dismiss(null);
    }

    @ViewChild('input', {static: false}) _input: any;    
    OnNumPad(key){
        if (this._input){
            this._input.OnKeyPress(key);
        }
    }

    OnCash(value){
        if (this._input){
            this._input.value = value.toString() + ".00";
        }
    }
}